import React from "react";
import { DialogContent, DialogClose, DialogDescription, DialogTitle } from "../ui/dialog";
import { X, Mail } from "lucide-react";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import Image from "next/image";
import ModalLayoutContent from "./ModalLayoutContent";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

type ModalContentComponentProps = {
  columnLeftData: any;
  imageUrl: string;
  customClassName?: string;
  onClose: () => void;
  onEnquireClick: () => void;
};

const ModalContentComponent: React.FC<ModalContentComponentProps> = ({
  columnLeftData,
  imageUrl,
  customClassName,
  onClose,
  onEnquireClick,
}) => (
  <DialogContent
    className={cn("w-full bg-transparent p-0", customClassName)}
    style={{
      maxWidth: "100%",
      height: "90vh",
      top: "55%",
      border: "none",
      borderTopLeftRadius: "3rem",
      borderTopRightRadius: "3rem",
      overflow: "hidden",
    }}
    hideDefaultCloseButton
  >
    <VisuallyHidden>
      <DialogTitle>Video Modal for the homepage carousel</DialogTitle>
    </VisuallyHidden>
    <VisuallyHidden>
      <DialogDescription>
        This is a video modal for the homepage carousel.
      </DialogDescription>
    </VisuallyHidden>
    <div className={cn("relative h-full w-full bg-white", customClassName)}>
      <DialogClose asChild>
        <button
          onClick={onClose}
          className="absolute right-8 top-8 z-10 rounded-full bg-white p-2 text-2xl text-black"
        >
          <X size={32} />
        </button>
      </DialogClose>
      <div className="grid h-full w-full grid-cols-2">
        <div className="col-span-1 flex flex-col items-center justify-start border-r p-10 pb-0">
          <ModalLayoutContent content={columnLeftData} />
        </div>
        <div className="relative col-span-1 flex items-center justify-center">
          <Image
            src={imageUrl}
            alt="Modal Image"
            fill
            style={{ objectFit: "cover" }}
            priority
          />
        </div>
      </div>
      <div className="absolute bottom-24 right-24 -translate-x-1/2 transform">
        <Button
          className="flex min-w-64 items-center space-x-2 rounded-full bg-gray-300 p-8 text-lg text-black"
          onClick={onEnquireClick}
        >
          <Mail size={20} />
          <span>Enquire</span>
        </Button>
      </div>
    </div>
  </DialogContent>
);

export default ModalContentComponent;
